import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, <React.StrictMode><App /></React.StrictMode>);
} else {
  createRoot(rootEl).render(<React.StrictMode><App /></React.StrictMode>);
}
